export interface Base {
  name: string;
  id: string;
}

export interface BaseTypeValue {
  type: string;
  value: string;
}
